// ----------------------------------------------------------------------

export default function SubscriptionsView() {
  return <>Subscriptions</>;
}
